<template>
  <section class="query">
    <div class="query-header">
      <com-tabs
        :list="statisticsInfo.obj.tabs1"
        class="query-tabs"
        :default-tab="activeTab"
        @change="changeTab"
      >
        <template v-slot:text="{ obj }">
          <div
            :class="{ activeTab: activeTab == obj.key }"
            class="query-tabs-item"
          >
            {{ obj.name }}
          </div>
        </template>
      </com-tabs>
      <span class="btn2">导出</span>
    </div>

    <div id="el-scroll" ref="details" class="query-content">
      <template>
        <section v-loading.fullscreen.lock="loading">
          <el-scrollbar ref="elScrollbar" wrap-style="overflow-x:hidden">
            <div class="term0">
              <div class="term0-top">
                <div class="term0-top-left">
                  <div class="term0-top-info">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                    >
                  </div>
                  <div class="term0-top-info">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                  </div>
                </div>
                <div class="term0-top-right">
                  <div>
                    任务名称:
                    <el-select v-model="value" placeholder="请选择">
                      <el-option
                        v-for="item in statisticsInfo.obj.options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.label"

                      />
                    </el-select>
                  </div>
                  <span @click="handleOptionTo">查询</span>
                </div>
              </div>
              <div v-if="this.option_value == '2022年装备统计' || this.value =='2022年装备统计' " class="term0-content">
                <div>
                  <div class="term0-content-title">
                    <img :src="require(`@/assets/statistics/sc.png`)" alt="">
                    <span>学校基本信息</span>
                  </div>
                  <com-term10 :data="data11" />
                </div>
                <div>
                  <div class="term0-content-title">
                    <img :src="require(`@/assets/statistics/sc.png`)" alt="">
                    <span>实验室情况</span>
                  </div>
                  <com-term11 :data="data12" />
                </div>
                <div>
                  <div class="term0-content-title">
                    <img :src="require(`@/assets/statistics/sc.png`)" alt="">
                    <span>图书馆情况</span>
                  </div>
                  <com-term12 :data="data13" />
                </div>
                <div>
                  <div class="term0-content-title">
                    <img :src="require(`@/assets/statistics/sc.png`)" alt="">
                    <span>音体美卫情况</span>
                  </div>
                  <com-term13 :data="data14" />
                </div>
                <div>
                  <div class="term0-content-title">
                    <img :src="require(`@/assets/statistics/sc.png`)" alt="">
                    <span>信息化设备情况</span>
                  </div>
                  <com-term14 :data="data15" />
                </div>
                <div>
                  <div class="term0-content-title">
                    <img :src="require(`@/assets/statistics/sc.png`)" alt="">
                    <span>课桌椅校服情况</span>
                  </div>
                  <com-term15 :data="data16" />
                </div>
                <div>
                  <div class="term0-content-title">
                    <img :src="require(`@/assets/statistics/sc.png`)" alt="">
                    <span>学生生活附属设施</span>
                  </div>
                  <com-term16 :data="data17" />
                </div>
              </div>
            </div>
          </el-scrollbar>
        </section>
      </template>
    </div>
  </section>
</template>
<script>
import mock from '@/utils/mock'
import comTabs from '@/components/comTabs'
import comTerm10 from './details/comTerm10.vue'
import comTerm11 from './details/comTerm11.vue'
import comTerm12 from './details/comTerm12.vue'
import comTerm13 from './details/comTerm13.vue'
import comTerm14 from './details/comTerm14.vue'
import comTerm15 from './details/comTerm15.vue'
import comTerm16 from './details/comTerm16.vue'
export default {
  name: 'ComQuery',
  components: {
    comTabs,
    comTerm10,
    comTerm11,
    comTerm12,
    comTerm13,
    comTerm14,
    comTerm15,
    comTerm16
  },
  props: {},
  data() {
    return {
      activeTab: 0,
      statisticsInfo: mock.statistics.statistics.viewInfo,
      statisticsInit: mock.statistics.statistics.init,
      loading: false,
      name: '',
      phone: '',
      value: '',
      option_value: null,
      data11: null,
      data12: null,
      data13: null,
      data14: null,
      data15: null,
      data16: null,
      data17: null
    }
  },
  computed: {},
  watch: {},
  created() {
    this.tableMode()
    this.value = this.statisticsInfo.obj.options[3].label
  },
  mounted() {
    const element = document.querySelector('#el-scroll')
    element.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    handleOptionTo() {
      this.option_value = this.value
    },
    async tableMode() {
      if (localStorage.getItem('form1')) {
        this.data11 = JSON.parse(localStorage.getItem('form1'))
      }
      if (localStorage.getItem('form2')) {
        this.data12 = JSON.parse(localStorage.getItem('form2'))
      }
      if (localStorage.getItem('form3')) {
        this.data13 = JSON.parse(localStorage.getItem('form3'))
      }
      if (localStorage.getItem('form4')) {
        this.data14 = JSON.parse(localStorage.getItem('form4'))
      }
      if (localStorage.getItem('form5')) {
        this.data15 = JSON.parse(localStorage.getItem('form5'))
      }

      if (localStorage.getItem('form6')) {
        this.data16 = JSON.parse(localStorage.getItem('form6'))
      }
      if (localStorage.getItem('form7')) {
        this.data17 = JSON.parse(localStorage.getItem('form7'))
      }
      const obj = await this.statisticsInit.tableMode()
      this.data1 = obj.slice(0, 22)
      this.loading = false
      this.data2 = obj.slice(22, 130)
      this.data3 = obj.slice(130, 176)
      this.data4 = obj.slice(176, 238)
      this.data5 = obj.slice(238, 317)
      this.data6 = obj.slice(317, 344)
      this.data7 = obj.slice(344, 352)
    },
    changeTab(x, y) {
      this.activeTab = x
    },

    handleOpen() {
      this.$alert(this.content, '查看指标解释', {
        confirmButtonText: '关闭',
        callback: (action) => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.query {
  margin-top: 20px;
  &-header {
    display: flex;
    justify-content: space-between;
    > span {
      cursor: pointer;
      padding: 6px 20px;
      border-radius: 5px;
    }
    .btn1 {
      background-color: #fff;
      border: 1px solid #d7d4d4;
      color: #333;
    }
    .btn2 {
      background-color: #2f82ff;
      border: 1px solid #2f82ff;
      color: #fff;
    }
  }
  &-tabs {
    width: 800px !important;
    display: flex;
    flex-direction: column;
    margin-right: 18px;

    &-item {
      text-align: center;
      font-size: 14px;
      color: #333;
      line-height: 30px;
      cursor: pointer;
    }
    .activeTab {
      color: #2f82ff;
      font-weight: bold;
      border-bottom: 2px solid #2f82ff;
    }
  }
  &-content {
    margin-top: 22px;
  }
}
.query /deep/ .tabs {
  justify-content: space-around;
  > div {
    flex: none;
  }
}
</style>
<style lang="scss" scoped>
.term0 {
  min-height: 720px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  &-top {
    display: inline-block;
    display: flex;
    justify-content: space-between;
    padding-bottom: 25px;
    border-bottom: 1px solid #d7d7d7;
    &-info {
      display: inline-block;
      line-height: 40px;
      margin-right: 30px;
      .el-input {
        width: 62%;
      }
    }
    &-right {
      display: flex;
      > span {
        margin-left: 20px;
        padding: 0px 15px;
        border: 1px solid #d7d7d7;
        line-height: 34px;
        cursor: pointer;
        color: #fff;
        background-color: #2f82ff;
      }
    }
  }
  &-content {
    .icon {
      cursor: pointer;
      position: absolute;
      right: 8px;
    }
    &-title {
      margin-top: 20px;
      img{
        vertical-align: middle;
      }
      span{
        vertical-align: middle;
      }
    }
  }
}
.term0-top-info /deep/ .el-input__inner {
  height: 34px;
}

</style>
